import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "PeriodListPage" */
	'pages/supplier/Period/PeriodListPage'));

export default [{ component, exact: true, path: '/periods' }];